import React, { useState } from 'react';
import { sendFeedback } from '../controller/PartyDB';
import { TUserId } from '../PartyClientResponse';
import { useAppState } from '../state/AppState';

const FeedbackForm = () => {
  const { user } = useAppState();
  const [feedback, setFeedback] = useState<string>('');
  const [sent, setSent] = useState<boolean>(false);

  if (!user) {
    return <div>You need to be logged in to use this.</div>;
  }

  const _sendFeedback = async () => {
    await sendFeedback(user!.uid as TUserId, feedback);
    setSent(true);
  };

  return (
    <div className='feedback'>
      {sent ? (
        <>
          <h2>Your feedback has been sent</h2>
          <p>You can close this tab now.</p>
        </>
      ) : (
        <>
          <h2>Send us some feedback.</h2>
          <p>This is not a final product yet, and we want to make it awesome!</p>
          <p>
            <textarea
              value={feedback}
              onChange={(e) => setFeedback(e.target.value)}
              rows={25}
              cols={70}
            />
          </p>
          <p>
            <button onClick={_sendFeedback}>Send Feedback</button>
          </p>
        </>
      )}
    </div>
  );
};

export default FeedbackForm;
